package platform

actual val platform: Platform = Platform.Web.Js